import { Component } from 'react';

class HomeRedirect extends Component {
  componentDidMount() {
    window.location.href = `${process.env.CARVANA_APP_BASE_URL}/sell-my-car${
      window.location.search ?? ''
    }`;
  }

  render() {
    return null;
  }
}

export default HomeRedirect;
